import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const WrapperStyle = () => ({
  margin: '0 auto',
  width: '100%',
  maxWidth: '530px'
});

export const Wrapper = styled(Stack)(WrapperStyle);

export const DialogContentStyle = ({ theme }) => ({
  marginTop: 24,
  padding: '0 16px 200px 16px',
  '::-webkit-scrollbar': {
    display: 'none'
  },
  [theme.breakpoints.up('md')]: {
    marginTop: 40,
    padding: '0 0 200px 0'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
